// Auto-generated by webpack - do not edit manually
export const availableComponents = {
  "product-warmup": {
    "name": "Produkto apšildymo planas",
    "icon": "🔥",
    "description": "Sudėlioti produkto apšildymo planą su datomis ir DI pagalba",
    "category": "content-strategy",
    "demoStages": [
      "Forma",
      "Planas (rodomas ir kol temos generuojasi)"
    ],
    "version": "0.1.0",
    "provider": "openai",
    "model": "gpt-4.1",
    "temperature": 0.7,
    "maxTokens": 2000,
    "responseFormat": "json_schema",
    "systemPrompt": "",
    "responseSchema": {}
  },
  "strategic-content": {
    "name": "Strateginis turinys",
    "icon": "📊",
    "description": "Generuoti strateginį turinį su DI pagalba",
    "category": "content-strategy",
    "demoStages": [
      "Forma",
      "Temos",
      "Kampai"
    ],
    "version": "1.0.0",
    "provider": "openai",
    "model": "gpt-4.1",
    "temperature": 1,
    "maxTokens": 8000,
    "responseFormat": "json_schema",
    "systemPrompt": "",
    "responseSchema": {}
  }
};

// Dynamic imports for component files
export const loadComponent = async (componentName) => {
    try {
        const component = await import(`./components/${componentName}/component.js`);
        return component.default;
    } catch (error) {
        console.error(`Failed to load component ${componentName}:`, error);
        return null;
    }
};
